import React from "react"
import useWindowDimensions from "../../../../hooks/useWindowDimensions"
import {
  amspaudaLogo,
  bioanalizesLogo,
  biomatterLogo,
  dspLogo,
  emailLogo,
  fbLogo,
  gitlabLogo,
  gmcLogo,
  igemLogo,
  igLogo,
  laboramaLogo,
  lineliberaLogo,
  medicinaPracticaLogo,
  progemLogo,
  thermoLogo,
  vortoGamaLogo,
  vuLogo,
  websiteLogo,
} from "../../../../static/svgs/footer"

const MobileFooter = () => {
  const { width } = useWindowDimensions()
  const igemLogoSizes = width
    ? width <= 375
      ? "h-28"
      : "w-52 h-40"
    : "w-52 h-40"
  return (
    <div className="flex flex-col w-full h-full px-8 pt-4 pb-7 gap-6">
      <div className="flex flex-row justify-center gap-14">
        <div className="flex flex-col justify-center">
          <img alt="" className={igemLogoSizes} src={igemLogo} />
        </div>
        <div className="flex flex-col justify-center gap-2">
          <div className="uppercase font-raleway-medium font-medium text-sm">
            FOLLOW US
          </div>
          <div className="flex flex-row justify-start gap-4">
            <a href="https://www.instagram.com/igem_vilnius" target="_blank">
              <img alt="" className="w-6 h-6" src={igLogo} />
            </a>
            <a href="https://www.facebook.com/VilniusiGEM" target="_blank">
              <img alt="" className="w-6 h-6" src={fbLogo} />
            </a>
          </div>
          <div className="uppercase font-raleway-medium font-medium text-sm">
            CONTACT US
          </div>
          <div className="flex flex-row justify-start gap-4">
            <a href="https://vilniusigem.lt/" target="_blank">
              <img alt="" className="w-6 h-6" src={websiteLogo} />
            </a>
            <a href="mailto:info@vilniusigem.lt">
              <img alt="" className="w-7 h-4 mt-1" src={emailLogo} />
            </a>
          </div>
          <div className="uppercase font-raleway-medium font-medium text-sm">
            WIKI REPOSITORY
          </div>
          <div className="flex flex-row justify-start">
            <a
              href="https://gitlab.igem.org/2022/vilnius-lithuania"
              target="_blank"
            >
              <img alt="" className="w-6 h-6" src={gitlabLogo} />
            </a>
          </div>
        </div>
      </div>
      <div className="w-full flex flex-row justify-center">
        <div className="inline-block border border-solid border-white w-5/6" />
      </div>
      <div className="flex flex-col justify-center gap-4 px-8">
        <div className="flex flex-row justify-center items-center gap-6">
          <a href="https://www.vu.lt/" target="_blank">
            <img alt="" src={vuLogo} />
          </a>
          <a href="https://www.thermofisher.com/" target="_blank">
            <img alt="" src={thermoLogo} />
          </a>
        </div>
        <div className="flex flex-row gap-6 justify-center items-center">
          <a href="https://medicinapractica.lt/" target="_blank">
            <img alt="" src={medicinaPracticaLogo} />
          </a>
          <a href="https://www.gmc.vu.lt/" target="_blank">
            <img alt="" src={gmcLogo} />
          </a>
          <a href="https://www.biomatterdesigns.com/" target="_blank">
            <img alt="" src={biomatterLogo} />
          </a>
        </div>
        <div className="flex flex-row gap-6 justify-center items-center">
          <a href="https://bioanalysis.lt/" target="_blank">
            <img alt="" src={bioanalizesLogo} />
          </a>
          <a href="https://linealibera.lt/" target="_blank">
            <img alt="" src={lineliberaLogo} />
          </a>
          <a href="https://linealibera.lt/" target="_blank">
            <img alt="" src={progemLogo} />
          </a>
          <a href="https://www.vortogama.lt/en/" target="_blank">
            <img alt="" src={vortoGamaLogo} />
          </a>
        </div>
        <div className="flex flex-row gap-6 justify-center items-center">
          <a href="https://www.laborama.lt/" target="_blank">
            <img alt="" src={laboramaLogo} />
          </a>
          <a href="https://darbosaugospriemones.lt/" target="_blank">
            <img alt="" src={dspLogo} />
          </a>
          <a href="https://amspauda.lt/" target="_blank">
            <img alt="" src={amspaudaLogo} />
          </a>
        </div>
      </div>
    </div>
  )
}

export default MobileFooter
